module.exports = "<h4 class=background-heading>Languages</h4> <p class=background-text><%- languages %></p> ";


//////////////////
// WEBPACK FOOTER
// ./templates/languages.html
// module id = 188
// module chunks = 0